<!-- eslint-disable -->
<template lang="pug">
    .row.generator(:class="[isLoading && 'generator--disabled']")
        .col-xs-12.col-xl-6.generator__box-container
            .generator__box
                template(v-if="user && !areSchoolsBlocked && user.type !== 'student'")
                    .generator__header {{ $i18n.t('trainer.trainer_generator_header') }}
                    div.generator__divider
                    form-group.generator__form-group(:label="$i18n.t('trainer.trainer_generator_gameType')")
                        cs-multiselect.generator__select(
                            :multiple="false",
                            :options="games",
                            :show-labels="false",
                            :allow-empty="false",
                            :placeholder="$i18n.t('trainer.trainer_generator_gameTypePlaceholder')",
                            label="label",
                            v-model="selectedGame"
                        )
                    div(
                        :is="formName",
                        v-if="selectedGame",
                        :selectedGame="selectedGame",
                        :is-loading="isLoading",
                        @cancel="$router.back()",
                        @generate="generate"
                    )
                    template(v-if="selectedGame && formName !== 'add-sub-form'")
                        .generator__divider
                        .generator__buttons-container
                            cs-button.generator__button(@click="$router.back()", pattern="primary-outline")
                                | {{ $i18n.t('trainer.trainer_generator_cancel') }}
                            cs-button.generator__button(@click="generate", :disabled="isLoading")
                                | {{ $i18n.t('trainer.trainer_generator_generate') }}
                div(v-else) {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
        .col-xs-12.col-xl-6.generator__box-container
            .generator__box.generator__box--pdf(v-if="user && user.type !== 'student'")
                cs-loader(v-if="isLoading")
                .generator__pdf-container#pdf-viewer(v-show="!isLoading")
                .generator__buttons-container(v-if="!isIE && !isEdge")
                    .generator__button-container(v-show="!isLoading")
                        a(
                            v-if="PDFUrl",
                            :href="PDFUrl",
                            target="_blank"
                        )
                            cs-button.generator__button {{ $i18n.t('trainer.trainer_generator_open') }}
                    cs-button.generator__button(
                        v-if="selectedGame",
                        v-show="!isLoading && PDFUrl",
                        @click="remakePDF",
                        v-text="$i18n.tc('trainer.trainer_generator_answersButton', selectedGame.showAnswers ? 0 : 1)"
                    )
</template>

<script>
    /*eslint-disable*/
    import Trainer from "../../config/trainer"
    import generateAddSub from '../../utils/trainer/generateNumbers'
    import generateMultDiv from '../../utils/multiplication-and-division/generateExample'
    import generateEquation from '../../utils/trainer/generateEquation'
    import generateAnzan from '../../utils/trainer/generateAnzan'
    import GamePDFApi from "../../api/games/gamePDF"
    import _ from "lodash"
    import {mapState} from 'vuex'
    const AddSubForm = () => import("./generator/AddSubForm.vue");
    const MultDivForm = () => import("./generator/MultDivForm.vue");
    const EquationForm = () => import("./generator/EquationForm.vue");
    const AnzanForm = () => import("./generator/AnzanForm.vue");
    import PDFJS from 'pdfjs-dist';
    import PDFWorker from 'pdfjs-dist/build/pdf.worker';
    import BillingBlockMixin from '../../utils/user/BillingBlockMixin';

    const formNames = {
        MultiplicationAndDivision: 'mult-div-form',
        AdditionAndSubtraction: 'add-sub-form',
        Equation: 'equation-form',
        Anzan: 'anzan-form',
    };

    export default {
        mixins: [generateAddSub, generateMultDiv, generateEquation, generateAnzan, BillingBlockMixin],
        beforeRouteEnter (to, from, next) {
            next(self => {
                if (!self.user.pointsAccesses.includes('mentalArithmetic')) {
                    self.$router.push({name: '403'});
                }
            });
        },
        data () {
            return {
                games: [
                    {
                        slug: "AdditionAndSubtraction",
                        name: "Сложение и вычитание",
                        label: this.$i18n.t('common.common_gameName_additionAndSubtraction'),
                        parameters: _.cloneDeep(_.find(Trainer.games, {slug: "AdditionAndSubtraction"}).parameters.default),
                        exercises: [],
                        text: null,
                        showAnswers: true,
                    },
                    {
                        slug: "MultiplicationAndDivision",
                        name: "Умножение и деление",
                        label: this.$i18n.t('common.common_gameName_multiplicationAndDivision'),
                        parameters: _.cloneDeep(_.find(Trainer.games, {slug: "MultiplicationAndDivision"}).parameters.default),
                        exercises: [],
                        text: null,
                        showAnswers: true,
                    },
                    {
                        slug: "Equation",
                        name: "Прятки",
                        label: this.$i18n.t('common.common_gameName_equation'),
                        parameters: _.cloneDeep(_.find(Trainer.games, {slug: "Equation"}).parameters.default),
                        exercises: [],
                        text: null,
                        showAnswers: true,
                    },
                    {
                        slug: "Anzan",
                        name: this.$i18n.t('common.common_gameName_anzan'),
                        label: this.$i18n.t('common.common_gameName_anzan'),
                        parameters: _.cloneDeep(_.find(Trainer.games, {slug: "Anzan"}).parameters.default),
                        exercises: [],
                        text: null,
                        showAnswers: true,
                    }
                ],
                selectedGame: null,
                parameters: null,
                correctAnswer: null,
                numbers: [],
                isLoading: false,
                PDFUrl: null,
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            isIE () {
                return false || !!document.documentMode;
            },
            isEdge () {
                return !this.isIE && !!window.StyleMedia;
            },
            formName () {
                return formNames[this.selectedGame.slug];
            },
            isFormCompleted () {
                return this.selectedGame
                        && (this.selectedGame.slug === 'AdditionAndSubtraction'
                                || this.selectedGame.slug === 'Equation'
                                || this.selectedGame.slug === 'Anzan'
                                || (
                                        this.selectedGame.slug === 'MultiplicationAndDivision'
                                        && (
                                                this.selectedGame.parameters.digitCapacity.left.length
                                                || this.selectedGame.parameters.numbers.length
                                        ) && (
                                                this.selectedGame.parameters.digitCapacity.right.length
                                                || this.selectedGame.parameters.tabulatedValue
                                        ) && (
                                                this.selectedGame.parameters.operations.multiply
                                                || this.selectedGame.parameters.operations.divide
                                        )
                                )
                        )
            }
        },
        methods: {
            generateAdditionAndSubtraction () {
                for (let i = this.parameters.amountOfExamples; i; i--) {
                    this.generateArrayOfNumbers();
                    this.$store.commit('setPreviousNumbers', {position: 'first', numbers: this.numbers});
                    this.selectedGame.exercises.push({
                        'numbers': this.numbers,
                        'answer': this.correctAnswer
                    });
                }
            },
            generateMultiplicationAndDivision () {
                for (let i = this.parameters.amountOfExamples; i; i--) {
                    this.generateExample()
                    let correctAnswer = this.example.operation === '*' ?
                            this.example.left * this.example.right : this.example.left / this.example.right
                    this.selectedGame.exercises.push({
                        'example': this.example,
                        'answer': correctAnswer
                    })
                }
            },
            generateEquation () {
                for (let i = this.parameters.amountOfExamples; i; i--) {
                    this.generateEquationNumbers()
                    this.selectedGame.exercises.push({
                        'example': this.numbers,
                        'answer': this.correctAnswer,
                        'sum': this.equationAnswer,
                    })
                }
            },
            generateAnzan () {
                for (let i = this.parameters.amountOfExamples; i; i--) {
                    this.generateAnzanNumbers()
                    this.selectedGame.exercises.push({
                        'numbers': this.numbers,
                        'answer': this.correctAnswer,
                    })
                }
            },
            generateAsync () {
                this[`generate${this.selectedGame.slug}`]()
                this.selectedGame.showAnswers = true
                this.getPDF()
            },
            generate () {
                if (this.isFormCompleted) {
                    this.isLoading = true
                    this.selectedGame.exercises = []
                    this.parameters = this.selectedGame.parameters
                    setTimeout(this.generateAsync, 20)
                } else {
                    this.$toasted.error(this.$i18n.t('trainer.trainer_generator_formNotFilled'))
                }
            },
            getPDF () {
                if (this.selectedGame.exercises.length) {
                    GamePDFApi.getPDF(this.selectedGame)
                    .then(url => {
                        this.PDFUrl = `${api.env.API_ENDPOINT}/${url}`
                        this.renderPDF(this.PDFUrl)
                    })
                    .catch(error => {
                        this.isLoading = false
                        if (error && error.data && error.data.message) {
                            this.$toasted.error(this.$root.$t(`errors.${error.data.message}`));
                        } else {
                            this.$toasted.error(this.$i18n.t('trainer.trainer_generator_generateError'))
                        }
                    })
                } else {
                    this.isLoading = false
                    this.$toasted.error(this.$i18n.t('trainer.trainer_generator_emptyList'))
                }
            },
            renderPDF (url) {
                if (!PDFJS.GlobalWorkerOptions.workerSrc) {
                    PDFJS.GlobalWorkerOptions.workerSrc = PDFWorker;
                }
                if (this.isIE || this.isEdge) {
                    this.isLoading = false
                    this.$toasted.error(this.$i18n.t('errors.not_able_to_work'));
                    return;
                }
                PDFJS.getDocument(url)
                .then(pdf => {
                    let elem = document.getElementById('pdf-viewer')
                    while (elem.lastChild) {
                        elem.removeChild(elem.lastChild)
                    }
                    for (let i = 1; i <= pdf.numPages; i++) {
                        let canvas = document.createElement('canvas')
                        canvas.setAttribute('class', 'canvas-pdf')
                        canvas.id = i
                        document.getElementById('pdf-viewer').appendChild(canvas)
                        pdf.getPage(i).then(page => {
                            this.renderPage(page, canvas, i === pdf.numPages)
                        })
                    }
                    let boxHeight = document.querySelector('.generator__box').clientHeight;
                    let buttonsHeight = 2 * document.querySelector('.generator__buttons-container').clientHeight;
                    let dividerHeight = document.querySelector('.generator__divider').offsetHeight;
                    elem.style['max-height'] = boxHeight - buttonsHeight - dividerHeight + 'px';
                })
                .catch(error => {
                    this.isLoading = false
                    this.$toasted.error(this.$i18n.t('trainer.trainer_generator_showError'))
                })
            },
            renderPage (page, canvas, lastPage) {
                let viewport = page.getViewport(1.5)
                let canvasContext = canvas.getContext('2d')
                let renderContext = {
                    canvasContext,
                    viewport
                };
                canvas.height = viewport.height
                canvas.width = viewport.width
                page.render(renderContext)
                .then(() => {
                    if (lastPage) {
                        this.isLoading = false
                    }
                })
            },
            remakePDF () {
                this.isLoading = true
                this.selectedGame.showAnswers = !this.selectedGame.showAnswers
                this.getPDF()
            }
        },
        components: {
            AddSubForm,
            MultDivForm,
            EquationForm,
            AnzanForm,
        }
    }
</script>

<style lang="scss">
    .canvas-pdf {
        width: 100%;
        border: 1px solid $color-grey-300;
        border-radius: $border-radius-20;
        background-color: $x-color-white;
        @include inset-space($space-small);
    }
</style>

<style lang="scss" scoped>
    .generator {
        margin: 0;
        padding: 0;
        height: 100%;
        background-color: $x-color-white;
        box-sizing: border-box;
        @include media($sm) {
            padding: 15px;
            border-radius: 40px;
        }
    }

    .generator__box-container {
        padding: 15px 0;
        @include media($sm) {
            padding: 15px;
        }
    }

    .generator__box {
        height: 100%;
        padding: 25px;
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
    }

    .generator__header {
        @include text($font-size-20);
        @include stack-space($space-small);
    }

    .generator__divider {
        @include stack-space($space-base);
        border-bottom: 1px solid $color-grey-300;
    }

    .generator__form-group {
        @include stack-space($space-base);
    }

    .generator__buttons-container {
        justify-content: flex-end;
        @include make-grid(0);
    }

    .generator__button {
        width: 100%;
        @include stack-space($space-small);
        @include media($sm) {
            width: unset;
            margin: unset;
            @include inline-space($space-small);
        }
    }

    .generator__button-container {
        width: 100%;
        @include stack-space($space-small);
        @include media($sm) {
            width: unset;
            margin: unset;
            @include inline-space($space-small);
        }
        text-align: center;
    }

    .generator__pdf-container {
        width: 100%;
        max-height: 450px;
        overflow: auto;
        @include media($sm) {
            max-height: 950px;
        }
        @include stack-space($space-base);
        &::-webkit-scrollbar-track {
            background: #E6E6F8;
        }
        &::-webkit-scrollbar {
            background-color: #E6E6F8;
            width: 4px;
        }
        &::-webkit-scrollbar-thumb {
            width: 4px;
            background: #C1C1F2;
        }
    }
</style>
